import milestoneService from 'resources/milestone/milestone.service';
import taskService from 'resources/task/task.service';

const getMilestonesWithTasks = async (listedKit) =>
  // TODO: add check on user id and listed kit company id
  // eslint-disable-next-line implicit-arrow-linebreak
  Promise.all(listedKit.milestone_ids.map(async (milestoneId) => {
    const milestone = await milestoneService.findById(milestoneId);

    const tasks = await taskService.getMilestoneTasks(milestoneId);

    if (milestone) {
      milestone.tasks = tasks;
    }

    return milestone;
  }));

export {
  getMilestonesWithTasks,
};
